import { Component, OnInit } from '@angular/core';
import { TextService } from 'src/app/services/text-service.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(public textDefinitions: TextService) { }

  ngOnInit() {
  }

}
